export default __webpack_public_path__ + "static/media/fcLogo.1fbd843b.png";